var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_spotlightElement"},[_vm._t("default"),(_vm.active)?_c('div',{staticClass:"bubbleLabel",attrs:{"direction":_vm.bubbleDirection}},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }